export class GenerateSearchId {
    handle() {
        const length = 24;
        // Characters to include in the code
        const characters = '0123456789abcdef';
        // Generate the code
        let result = '';
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    }
}
